import type { FunctionComponent, ReactNode } from "react";

import { PlusArchiveFilterTabs } from "scmp-app/components/plus/plus-archive-header/filter-tabs";

import { Header, PageTitle } from "./styles";

type Props = {
  children?: ReactNode;
  title: string;
};

export const PlusArchiveHeader: FunctionComponent<Props> = ({ children, title }) => (
  <Header>
    <PageTitle>{title}</PageTitle>
    <PlusArchiveFilterTabs />
    {children}
  </Header>
);

PlusArchiveHeader.displayName = "PlusArchiveHeader";
